import React, { FC } from 'react'
import AutocompleteBase, { IAutocompleteBaseOption } from 'transfix-ui/components/AutocompleteBase'
import { capitalize } from 'utils/capitalize'

interface IAutocompleteLocationsProps {
  locations: IAutocompleteBaseOption[]
  locationSelection: string
  isLoading: boolean
  onAutocompleteChange: (_: any, value: any) => void
  type: 'pickup' | 'delivery'
  disabled?: boolean
}

export const AutocompleteLocations: FC<IAutocompleteLocationsProps> = props => {
  const {
    disabled,
    isLoading,
    locationSelection: locationSelectedID,
    locations,
    onAutocompleteChange,
    type,
  } = props

  const locationData = locations.find(location => location.id === locationSelectedID)

  return (
    <AutocompleteBase
      data-test={`Transfix-Shipper-App-${capitalize(type)}LocationSelect`}
      key={locationData?.id}
      inputIcon='LocationPin'
      renderInputType='withIcon'
      options={locations}
      loading={isLoading}
      value={locationData}
      onChange={onAutocompleteChange}
      defaultValue={locations[0]}
      disableClearable
      disabled={disabled}
    />
  )
}
